module.exports = __webpack_public_path__ + "images/arrow_down.png";